import EditTemplatePage from './EditTemplatePage';

export default EditTemplatePage;
